/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Affiliate Postback Receiver API
 * Production-ready S2S postback ingestion and querying service for affiliate marketing platforms.

## Features
- **Postback Ingestion**: Accept affiliate conversion events via GET/POST webhooks
- **Deduplication**: Automatic duplicate detection to prevent double counting
- **Event Normalization**: Standardize events from multiple affiliate networks
- **Query API**: Search and filter historical events with pagination
- **Analytics**: Statistics aggregations and CSV export for reporting
- **Health Checks**: Kubernetes-ready liveness and readiness probes
- **Metrics**: Prometheus-compatible metrics for monitoring

## Supported Networks
- Referon (via `/postbacks/referon` endpoint)

## Event Types
- **CLICK**: User clicked on affiliate link
- **REG**: User registration
- **FTD**: First-time deposit
- **DEP**: Regular deposit
- **REDEP**: Repeat deposit
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { AuthTokenResponseDto, TelegramAuthDto } from '.././model';

import { customFetch } from '../../../shared/api/custom-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Verify Telegram WebApp initData and issue access token. In development mode, accepts devUserId via X-Dev-User-Id header.
 * @summary Authenticate with Telegram WebApp
 */
export type authControllerAuthenticateTelegramResponse200 = {
  data: AuthTokenResponseDto;
  status: 200;
};

export type authControllerAuthenticateTelegramResponse401 = {
  data: void;
  status: 401;
};

export type authControllerAuthenticateTelegramResponseSuccess =
  authControllerAuthenticateTelegramResponse200 & {
    headers: Headers;
  };
export type authControllerAuthenticateTelegramResponseError =
  authControllerAuthenticateTelegramResponse401 & {
    headers: Headers;
  };

export type authControllerAuthenticateTelegramResponse =
  | authControllerAuthenticateTelegramResponseSuccess
  | authControllerAuthenticateTelegramResponseError;

export const getAuthControllerAuthenticateTelegramUrl = () => {
  return `/auth/telegram`;
};

export const authControllerAuthenticateTelegram = async (
  telegramAuthDto: TelegramAuthDto,
  options?: RequestInit,
): Promise<authControllerAuthenticateTelegramResponse> => {
  return customFetch<authControllerAuthenticateTelegramResponse>(
    getAuthControllerAuthenticateTelegramUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(telegramAuthDto),
    },
  );
};

export const getAuthControllerAuthenticateTelegramMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authControllerAuthenticateTelegram>>,
    TError,
    { data: TelegramAuthDto },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authControllerAuthenticateTelegram>>,
  TError,
  { data: TelegramAuthDto },
  TContext
> => {
  const mutationKey = ['authControllerAuthenticateTelegram'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authControllerAuthenticateTelegram>>,
    { data: TelegramAuthDto }
  > = (props) => {
    const { data } = props ?? {};

    return authControllerAuthenticateTelegram(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerAuthenticateTelegramMutationResult = NonNullable<
  Awaited<ReturnType<typeof authControllerAuthenticateTelegram>>
>;
export type AuthControllerAuthenticateTelegramMutationBody = TelegramAuthDto;
export type AuthControllerAuthenticateTelegramMutationError = void;

/**
 * @summary Authenticate with Telegram WebApp
 */
export const useAuthControllerAuthenticateTelegram = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authControllerAuthenticateTelegram>>,
      TError,
      { data: TelegramAuthDto },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authControllerAuthenticateTelegram>>,
  TError,
  { data: TelegramAuthDto },
  TContext
> => {
  const mutationOptions = getAuthControllerAuthenticateTelegramMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
